import React from "react";
// 🔥 Dhyan dein: Hum maan rahe hain ki icon.png aur Loader.js EK HI FOLDER me hain
import companyLogo from "./icon.png"; 

function Loader() {
  return (
    <div style={containerStyle}>
      
      {/* 🚀 Rocket ki jagah ye Image Code hai */}
      <img 
        src={companyLogo} 
        alt="Loading..." 
        style={logoStyle} 
      />

      {/* Spinner */}
      <div className="spinner"></div>
      <style>{`
        .spinner {
          border: 4px solid #f3f3f3;
          border-top: 4px solid #3498db;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      
      <p style={{marginTop:"10px", color:"#555", fontWeight:"bold"}}>Please Wait...</p>
    </div>
  );
}

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  width: "100%",
  backgroundColor: "rgba(255,255,255,0.95)",
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 9999
};

const logoStyle = {
  width: "100px",  // Logo ka size
  height: "auto",
  marginBottom: "15px",
  objectFit: "contain"
};

export default Loader;